import { Compass } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import { Button } from '@/components/ui/button';
import { EmptyState } from '@/components/ui/empty-state';

/**
 * Shown for any route inside the shell that does not resolve.
 *
 * Offers a way back rather than only an apology — a dead end with no action is
 * exactly the kind of rough edge §15 rejects.
 */
export function NotFoundPage() {
    const { t } = useTranslation(['common', 'nav']);

    return (
        <EmptyState
            icon={Compass}
            title={t('common:state.not_found_title', {
                defaultValue: 'Page not found',
            })}
            description={t('common:state.not_found_description', {
                defaultValue:
                    'The page you were looking for does not exist or has moved.',
            })}
            action={
                <Button asChild variant="outline" size="sm">
                    <Link to="/dashboard">{t('nav:dashboard')}</Link>
                </Button>
            }
        />
    );
}

export default NotFoundPage;
